import { z } from "zod";

export const audiofileSchema = () => {
  return z.object({
    position: z.string().min(1),
    book: z.number().optional().nullable(),
    file: z.any().optional().nullable(),
  });
};

export type AudioFileFormValues = z.infer<ReturnType<typeof audiofileSchema>>;
